import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { DocumentsIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { List } from 'foundations-components/transitional/components/List';
import { LearningMaterialTypes } from 'academy-shared-js/constants/ContentConstants';
import { Link } from '../AcademyLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ResourceItem = ({
  title,
  url,
  prefix,
  onResourceClick
}) => {
  const handleLinkClick = () => onResourceClick({
    title,
    url
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [prefix, /*#__PURE__*/_jsx(Link, {
      external: true,
      href: url,
      onClick: handleLinkClick,
      children: title
    })]
  });
};
const ResourcesList = ({
  additionalResources = [],
  onResourceClick = () => {},
  slidesUrl,
  transcriptUrl
}) => {
  if (!slidesUrl && !transcriptUrl && !additionalResources.length) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.noLessonResources"
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonResources"
      })
    }), /*#__PURE__*/_jsxs(List, {
      children: [slidesUrl && /*#__PURE__*/_jsx(ResourceItem, {
        onResourceClick: onResourceClick,
        prefix: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-core-subtle",
          icon: DocumentsIcon
        }),
        title: I18n.text('learningCenter.resources.downloadSlides'),
        url: slidesUrl
      }), transcriptUrl && /*#__PURE__*/_jsx(ResourceItem, {
        onResourceClick: onResourceClick,
        prefix: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-core-subtle",
          icon: DocumentsIcon
        }),
        title: I18n.text('learningCenter.resources.downloadTranscript'),
        url: transcriptUrl
      }), additionalResources.map(resource => /*#__PURE__*/_jsx(ResourceItem, {
        onResourceClick: onResourceClick,
        prefix: /*#__PURE__*/_jsxs(_Fragment, {
          children: [LearningMaterialTypes[resource.type] ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.resources.type.${resource.type}`
          }) : resource.type, ":\xA0"]
        }),
        title: resource.title,
        url: resource.targetUrl
      }, resource.title))]
    })]
  });
};
export default ResourcesList;